import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import { Theme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { SxProps } from '@mui/system';
import React from 'react';

interface Props {
  children: React.ReactNode;
  title?: string;
  sx?: SxProps<Theme>; // Style
}

const SimpleCard = ({ children, title = '', sx = {} }: Props) => {
  return (
    <Paper elevation={0} sx={{ ...sx }}>
      {title ? <Typography variant="group-title">{title}</Typography> : null}
      <Box sx={{ p: 2 }}>{children}</Box>
    </Paper>
  );
};

export { SimpleCard };
